import { observer } from "mobx-react-lite";
import "./NationalLeague.css";
import { useFontDesk } from "../../context/frontDeskContext";
import TopBar from "../../components/topBar/TopBar";
import { isMobile } from "react-device-detect";
import { Strings } from "../../utils/strings";
import { CustomDialog } from "../../components/dialog/CustomDialog";
import { useNationalLeagueStore } from "../../store/StoreContext";
import { ExpandableFAB } from "../../components/expandableFAB/ExpandableFab";
import { CreateLeagueBottomSheet } from "./widgets/CreateLeagueSheet";
import { AllNationalLeagues } from "./widgets/AllNationalLeagues";
import { useEffect, useRef } from "react";
import LoadingIndicator from "../../components/loadingIndicator/LoadingIndicator";

const NationalLeague = observer(() => {
  const { onLogOut } = useFontDesk();
  const nationalLeagueStore = useNationalLeagueStore();

  const hasFetched = useRef(false);

  useEffect(() => {
    if (!hasFetched.current) {
      nationalLeagueStore.fetchLeagues();
      nationalLeagueStore.setLeagueId(undefined);
      hasFetched.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      style={{
        paddingBottom: 30,
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        position: "relative", // Added for positioning the FAB
        marginTop: 80,
        overflowAnchor: "none",
      }}>
      <TopBar
        isBack={isMobile}
        onLogout={() => {
          nationalLeagueStore.modalData = {
            visible: true,
            title: Strings.LOGOUT,
            children: Strings.LOGOUT_WARNING,
            btnText: Strings.LOGOUT,
            btnVariant: "outline-danger",
            headerIcon: <div />,
            onClose: () => {
              nationalLeagueStore.modalData = undefined;
            },
            onAccept: () => {
              nationalLeagueStore.modalData = undefined;
              onLogOut();
            },
          };
        }}
      />
      <AllNationalLeagues />
      <ExpandableFAB
        options={[
          {
            id: 1,
            title: "Create League",
            onClick() {
              nationalLeagueStore.isCreateLeagueSheetVisible = true;
            },
          },
        ]}
      />
      <CreateLeagueBottomSheet
        showBottomSheet={nationalLeagueStore.isCreateLeagueSheetVisible}
        closeBottomSheet={() => {
          nationalLeagueStore.isCreateLeagueSheetVisible = false;
        }}
      />
      <CustomDialog
        visible={nationalLeagueStore.modalData?.visible ?? false}
        title={nationalLeagueStore.modalData?.title ?? ""}
        description={nationalLeagueStore.modalData?.children ?? ""}
        onCancel={nationalLeagueStore.modalData?.onClose}
        onConfirm={nationalLeagueStore.modalData?.onAccept}
      />
      <LoadingIndicator loading={nationalLeagueStore.isLoading} />
    </div>
  );
});

export default NationalLeague;
